function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "#e00d2e",
  d: "M75.377 147.63a73.715 73.715 0 1 1 0-147.43 73.71 73.71 0 0 1 0 147.42zm-55.37-25.07h21.33l13.48-22.93a71.41 71.41 0 0 0 2.53-5c.56-1.27.98-2.41 1.24-3.43.22.97.6 2.04 1.13 3.22a66.66 66.66 0 0 0 2.8 5.21l13.32 22.93h48.35L82.407 68.7l36.84-47.25h-48.23l-8.67 16.5-.48.9a53.3 53.3 0 0 0-3.29 7.46 34.8 34.8 0 0 0-1.4-3.69 127.6 127.6 0 0 0-2.21-4.66l-8.9-16.51h-22.45a73.98 73.98 0 0 0-12.65 16.6l23.78 30.65-26.91 34.8a73.76 73.76 0 0 0 12.16 19.05z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fill: "#fec702",
  d: "M119.237 21.44h-48.21l-8.67 16.5-.48.9a53.3 53.3 0 0 0-3.29 7.46c-.37-1.19-.84-2.42-1.4-3.69-.56-1.26-1.3-2.82-2.21-4.66l-8.9-16.51h-22.46a73.97 73.97 0 0 0-12.65 16.61l23.78 30.65-26.91 34.8a73.76 73.76 0 0 0 12.16 19.05h21.34l13.48-22.93a71.4 71.4 0 0 0 2.53-5c.56-1.27.98-2.41 1.24-3.43.22.97.6 2.04 1.13 3.22a66.67 66.67 0 0 0 2.8 5.21l13.32 22.93h48.35L82.407 68.7z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fill: "#fec702",
  d: "M282.517 77.69l20.84 30.42h-19.27l-11.2-18.17-11.49 18.16h-20.02l22.5-31.79-21.77-31.07-1.48-2.1h19.27l13.6 20.92 13.99-20.92h20.02l-1.16 1.6z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  fill: "#fec702",
  d: "M314.118 57.48h12.1v50.63h17.39V57.48h21.16V43.12h-60.64a45.92 45.92 0 0 1 9.99 14.36m-83.72 36.65a45.9 45.9 0 0 0 9.82 13.98h-53.24V43.12h52.52a45.94 45.94 0 0 0-9.42 13.98h-23.74v12.85h20.3a45.9 45.9 0 0 0 .31 12.85h-20.61v11.33h24.05m249.78-50.99h-24.38l-24.2 64.97h19.76l3.87-11.69h24.94l3.77 11.69h20.41zm-20.6 40.05l8.12-24.55h.38l7.84 24.55zm-31.38-18.73c0-13.22-9.07-21.34-25.68-21.34h-32.81l-.01 65h17.37V86.55h11.4l13.52 21.54h18.88l-15.8-23.81c8.6-3.59 13.13-10.95 13.13-19.82m-27.19 9.25h-13.94V56.34h13.94c6.04 0 9.44 3.21 9.44 8.31 0 5.47-3.4 9.06-9.44 9.06"
});

const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  shaperendering: "geometricPrecision",
  viewBox: "0 0 506 148"
}, props), _ref, _ref2, _ref3, _ref4);

export default __webpack_public_path__ + "static/media/coop-extra.136ec0e3.svg";
export { SvgComponent as ReactComponent };